import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/views/layout/Layout.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/login/Login.vue'),
        meta: { title: '登录' }
    },
    {
        path: '/',
        component: Layout,
        redirect: '/dashboard',
        children: [
            {
                path: '/dashboard',
                name: 'Dashboard',
                component: () => import('@/views/dashboard/Dashboard.vue'),
                meta: { title: '概览' }
            }
        ]
    },
    {
        path: '/admin',
        component: Layout,
        redirect: '/admin/profile',
        children: [
            {
                path: 'add',
                name: 'UserAdd',
                component: () => import('@/views/admin/Add.vue'),
                meta: { title: '添加用户' }
            },
            {
                path: 'password',
                name: 'Password',
                component: () => import('@/views/admin/Password.vue'),
                meta: { title: '修改密码' }
            },
            {// 新增个人中心路由
                path: 'profile',
                name: 'Profile',
                component: () => import('@/views/admin/Profile.vue'),
                meta: { title: '个人中心' }
            }
        ]
    },
    {
        path: '/users',
        component: Layout,
        redirect: '/users/user',
        children: [
            {
                path: 'user',
                name: 'User',
                component: () => import('@/views/user/User.vue'),
                meta: { title: '用户列表' }
            },
            {
                path: 'node/:id',
                name: 'NodeDetail',
                component: () => import('@/views/user/Node.vue'),
                meta: { title: '修改节点邀请人' }
            },
            {
                path: 'invite/:id',
                name: 'InviteDetail',
                component: () => import('@/views/user/Invite.vue'),
                meta: { title: '修改直推人' }
            },
            {
                path: 'import/list',
                name: 'ImportNodeInviteCode',
                component: () => import('@/views/invite/ImportList.vue'),
                meta: { title: '导入节点邀请码文件' }
            }
            /*{
                path: 'add',
                name: 'UserAdd',
                component: () => import('@/views/admin/Add.vue'),
                meta: { title: '添加用户' }
            },
            {
                path: 'password',
                name: 'Password',
                component: () => import('@/views/admin/Password.vue'),
                meta: { title: '修改密码' }
            },
            {// 新增个人中心路由
                path: 'profile',
                name: 'Profile',
                component: () => import('@/views/admin/Profile.vue'),
                meta: { title: '个人中心' }
            }*/
        ]
    },
    {
        path: '/invite',
        component: Layout,
        redirect: '/invite/index',
        children: [
            {
                path: 'index',
                name: 'index',
                component: () => import('@/views/invite/Index.vue'),
                meta: { title: '邀请码' }
            }
        ]
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
    const token = localStorage.getItem('token')
    if (to.path !== '/login' && !token) {
        next('/login')
    } else if (to.path === '/login' && token) {
        next('/')
    } else {
        next()
    }
})

// ============ 修复重复导航错误 ============
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace

// push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
            throw err
        }
    })
}

// replace
VueRouter.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
            throw err
        }
    })
}

export default router
